import { Component, OnInit } from '@angular/core';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';

@Component({
  selector: 'user-show-profile',
  templateUrl: './user-show-profile.component.html',
  styleUrls: ['./user-show-profile.component.css']
})
export class UserShowProfileComponent implements OnInit {

  user = new UserDto();
  userId!:string;
  isUserRetrieved = false;
  isTenantsRetrieved = false;
  userTenants: UserTenantDto[] = [];
  isAuthenticated = false;
  isConfirmed = false;
  isNoTenantAssigned = false;

  constructor(
    private oauthService: OAuthServiceService,
    private userProfileService: UserProfileService,
    private tenantService: TenantService

  ) { }

  ngOnInit() {
    console.log("--------------> user-show-profile");

    this.oauthService.userData.subscribe({
      next: (data: any) => {
        if (typeof data != undefined && data != null) {
          this.isAuthenticated = true;
          this.userId = data.sub;
          this.getUser(data.sub);
        }
      }
    });
    if(this.isAuthenticated) {
      //this.getTenants(this.userId);
    }

  }

  getUser(id: string) {
    // lesen in USERPROFILE der TenantDB (Namen korrekt, aber die Tel.Nr. ist tenantspezifisch)
    // this.tenantService.getUser(this.tenantService.currentTenantName, id).subscribe({

    //   next:(userDto:UserDto) => { 
    //     this.user = userDto;
    //     console.log("--------> retrieved user = ", this.user);
    //     this.isUserRetrieved = true; 
    //     this.getTenants(this.userId);  
    //   },
    //   error: (error: any) => {
    //   }
    // });



    // lesen in USERPROFILE der MainDB (Namen und allg. Tel.Nr.)
    console.log("user-show-profile: ============== getUserById =============")
    this.userProfileService.getUserById(id).subscribe({
      next:(userProfile: UserProfileForCreation) => {       
      this.user.id = id;
      this.user.email = userProfile.email;
      this.user.emailConfirmed = userProfile.isEmailConfirmed;
      this.user.first_Name = userProfile.givenName;
      this.user.last_Name = userProfile.familyName;
      this.user.phoneNumber = userProfile.phoneNumber;
      this.isUserRetrieved = true; 
      console.log("--------> retrieved user = ", this.user);
      this.getTenants(this.userId);  
      }

    });
  }

  getTenants(userId: string) {
   this.tenantService.getUserTenantz(userId, new GenericFilter).subscribe({
    //this.tenantService.getTenants(new GenericFilter).subscribe({
      next:(tenantDtos:UserTenantDto[]) => { 
        if (tenantDtos.length == 0) {
          console.log("user-show-profile component: no tenant!")
          this.isNoTenantAssigned = true;
          this.isTenantsRetrieved = true;
        }
        else{
          this.userTenants = tenantDtos;
          this.isTenantsRetrieved = true;

          console.log("--------> retrieved tenants = ", this.userTenants)  
          // let confirmed = true;
          // //let notConfirmedUserTenants: UserTenantDto[] = [];
          // this.userTenants.forEach(function (userTenant) {
          //   if (!userTenant.isConfirmed) {
          //     confirmed = false;
          //     //notConfirmedUserTenants.push(userTenant);
          //   }
          // })
          // this.isConfirmed = confirmed;
          // 
        }   
      },
      error: (error: any) => {
      }
    });

  }


  onChange(user: UserDto){

    //this.isConfirmed = true;
    this.userProfileService.currentUserName = user.first_Name + " " + user.last_Name;
  }

}
